import React from "react";
import './footer.css';
const Footer = () => {
  return (
   <footer className="footer">
    Copyright @samirbogati, SAMIR BOGATI.2024. ALL RIGHTS RESERVED.
   </footer>
  );
}
export default Footer;